import { useCallback, useEffect, useState } from 'react'
import { useAppSettings } from 'components/providers/AppSettingsProvider'
import dayjs from 'dayjs'
import { appCalendarDate } from 'utils/timezone'

interface UseMidnightTriggerOptions {
  onMidnight?: () => void
  enabled?: boolean
}

export const useMidnightTrigger = (options: UseMidnightTriggerOptions = {}) => {
  const { onMidnight, enabled = true } = options
  const { timeZone } = useAppSettings()
  const [currentDate, setCurrentDate] = useState(() => appCalendarDate())
  const [midnightCount, setMidnightCount] = useState(0)

  const triggerMidnightUpdate = useCallback(() => {
    setCurrentDate(appCalendarDate())
    setMidnightCount((prev) => prev + 1)
    onMidnight?.()
  }, [onMidnight])

  useEffect(() => {
    if (!enabled) return
    let timeoutId: ReturnType<typeof setTimeout>
    const scheduleMidnight = () => {
      const tomorrow = dayjs.tz(appCalendarDate(1), timeZone)
      timeoutId = setTimeout(() => {
        triggerMidnightUpdate()
        // Recompute each midnight: a DST day need not have 24 hours.
        scheduleMidnight()
      }, tomorrow.valueOf() - Date.now())
    }
    scheduleMidnight()
    return () => clearTimeout(timeoutId)
  }, [enabled, triggerMidnightUpdate, timeZone])

  return { currentDate, midnightCount, triggerMidnightUpdate }
}
